module.exports = __webpack_public_path__ + "static/bs-switch-merchant-users-logos-dd4dabf4c6c4db6ed48cbf8b5bd12181.png";